export class CssColorsGetter {
    public static get(nativeElement: HTMLElement, name: string): string {
        const css = getComputedStyle(nativeElement);
        const value = css.getPropertyValue(name).trim();
        if (value === '') {
            throw new Error(`CSS custom property '${name}' is not defined or has no value in learning progress history chart`);
        }
        return value;
    }
}
